require('./blocks/catalog.less');
require('./blocks/mini-filter/mini-filter');
require('./blocks/label-select.less');
require('./blocks/seminar.less');
require('./blocks/pagination.less');
require('./blocks/reviews/reviews');
require('./blocks/review.less');
require('./blocks/seo-catalog.less');

require('./blocks/seminar-list/seminar-list.js');
require('./plugins/jquery.loader/require.js');
require('./blocks/web-form/web-form.js');



// WEBPACK FOOTER //
// ./calendar.js